
import ReportBuilder from '../ReportBuilder'

export default {
  components: {
    ReportBuilder
  },
  data: function () {
    return {
      isGrouped: false,
      headers: []
    }
  },
  computed: {
    selectedColumns () {
      return this.columnOptions
        .filter(c => !c.optional || this.reportFilters.columns.find(cId => c.id === cId))
    },
    groupingOptionMap () {
      return this.groupingOptions.reduce((result, item) => {
        result[item.id] = item
        return result
      }, {})
    },
    selectedGroupingFilters () {
      return this.selectedGrouping
    },
    selectedGrouping () {
      return (this.groupingOptionMap[this.reportFilters.grouping] || {}).group || []
    }
  },
  /**
   * TODO: Move any methods than don't require access to "this" to a helpers include
   *       There is overhead in calling this.xxx methods
   */
  methods: {
    getGroupFields (grouping) {
      const found = {}
      const fields = []
      grouping = grouping || this.groupingOptionMap[this.reportFilters.grouping]
      if (grouping) {
        for (let group of grouping.group || []) {
          let field = (group.by || [])[0]
          if (!found[field]) {
            found[field] = true
            fields.push(field)
          }
        }
        for (let field of grouping.fields || []) {
          found[field] = true
          fields.push(field)
        }
      }
      return fields
    },
    getHeaders () {
      return this.selectedColumns.reduce((result, item) => {
        if (item.vColumns) {
          const vColumns = []
          item.vColumns.forEach(c => {
            if (c.__aggregateSpan === undefined) this.$set(c, '__aggregateSpan', 0)
            vColumns.push(c)
          })
          result.push(...item.vColumnSort ? vColumns.sort(item.vColumnSort) : vColumns)
        } else {
          if (item.column.__aggregateSpan === undefined) this.$set(item.column, '__aggregateSpan', 0)
          result.push(item.column)
        }
        return result
      }, [])
    },
    skipRow (row, rowIndex) {
      return false
    },
    extraSortOrder (f) {
      return []
    },
    sortOrder (f) {
      // Since we're doing any aggregates in javascript, first order by grouping fields
      const result = ((this.groupingOptionMap[f.grouping] || {}).group || []).reduce((agg, item) => {
        agg.push(item.by.join(':'))
        return agg
      }, [])
      result.push(...this.extraSortOrder(f))
      return result
    },
    groupOrder (f) {
      return null // We'll do our aggregates in javascript for this report
    },
    getExtraIncludeFields () {
      return []
    },
    getIncludedFields () {
      const found = {}
      // Add any fields needed from selected columns
      const fields = this.selectedColumns.reduce((result, item) => {
        for (let field of item.fields) {
          if (!found[field]) {
            found[field] = true
            result.push(field)
          }
        }
        return result
      }, [])
      // Add fields for selected group by fields
      for (let field of this.getGroupFields()) {
        if (!found[field]) {
          found[field] = true
          fields.push(field)
        }
      }
      // Add any extra fields
      for (let field of this.getExtraIncludeFields()) {
        if (!found[field]) {
          found[field] = true
          fields.push(field)
        }
      }
      // Add any extra fields
      if (this.getDefaultIncludeFields) {
        for (let field of this.getDefaultIncludeFields()) {
          if (!found[field]) {
            found[field] = true
            fields.push(field)
          }
        }
      }
      return fields
    },
    includeFields (f) {
      return this.getIncludedFields()
    },
    newAggregator (aggregateColumns, grouping) {
      const aggregator = {grouping: grouping}
      return this.resetAggregates(aggregateColumns, aggregator)
    },
    resetAggregates (aggregateColumns, aggregator) {
      const aggregates = {}
      for (let c of aggregateColumns) {
        aggregates[c.field] = typeof c.aggregateDefault === 'function' ? c.aggregateDefault() : c.aggregateDefault
      }
      aggregator.aggregates = aggregates
      return aggregator
    },
    aggregateRows (row, aggregateColumns, aggregator, rowIndex, rows) {
      var field
      const aggregates = aggregator.aggregates
      for (let c of aggregateColumns) {
        field = c.field
        aggregates[field] = c.aggregate(aggregates[field], row, rowIndex, rows, c)
      }
    },
    resetVColumns (vColumnItems) {
      for (let vColumnItem of vColumnItems) {
        vColumnItem.vColumns = []
        vColumnItem._vColumnLookup = {}
      }
    },
    buildVColumnsFromRow (row, vColumnItems) {
      for (let vColumnItem of vColumnItems) {
        vColumnItem.buildVColumnFromRow(row, vColumnItem.vColumns, vColumnItem._vColumnLookup, vColumnItem)
      }
    },
    groupReport (data) {
      const groupings = this.selectedGroupingFilters
      if (groupings && groupings.length) {
        // Break results into different groups
        var group, newBody, addGroupAction, newGroup, endGroup, field, bodyClass, groupingAction, aggregator
        this.isGrouped = true
        const usedClasses = new WeakSet()
        const bodyClasses = []
        // Do we need to build any extra columns? (Must do it before getting headers)
        const vColumnItems = this.selectedColumns.filter(vc => typeof vc.buildVColumnFromRow === 'function')
        if (vColumnItems.length) {
          // We'll need to iterate each item in the report data to build vColumns
          // First reset them
          this.resetVColumns(vColumnItems)
          // Then build them
          for (let row of data) {
            this.buildVColumnsFromRow(row, vColumnItems)
          }
        }
        // Get columns that we'll aggregate, and reset aggregate spans
        const headers = this.getHeaders() // Get headers, including any dynamic headers we may have just built
        this.headers = headers // Set data.headers so ReportBuilder vue instance can see them
        const headersMap = new WeakMap()
        const aggregateColumns = headers.filter((c, i) => {
          headersMap.set(c, i)
          c.__aggregateSpan = 0
          return c.aggregate
        })
        // Set spans for aggregate columns
        let lastAggregateColumn = 0
        var between, col
        aggregateColumns.forEach((c, i, a) => {
          col = headersMap.get(c)
          between = col - lastAggregateColumn
          if (between) {
            (a[i - 1] || headers[0]).__aggregateSpan = between
          }
          lastAggregateColumn = col
        })
        let aggregateCount = aggregateColumns.length
        if (lastAggregateColumn < headers.length && aggregateCount) {
          aggregateColumns[aggregateColumns.length - 1].__aggregateSpan = headers.length - lastAggregateColumn
        }
        // Define aggregators
        const aggregators = groupings
          .filter(g => g.showAggregates)
          .map(g => {return this.newAggregator(aggregateColumns, g)})
        // Add totals aggregator
        const totalAggregator = this.newAggregator(aggregateColumns, {aggregateLabel: 'Report Total', aggregateRowClass: 'ft-aggregate-total'})
        aggregators.push(totalAggregator)
        // Create lookup map for aggregators
        const aggregatorMap = new WeakMap()
        aggregators.forEach(a => aggregatorMap.set(a.grouping, a))
        // Group / aggregate rows
        const filteredData = data.filter((d, i) => !this.skipRow(d, i))
        let recordCount = filteredData.length
        const groupedData = filteredData.reduce((result, row, rowIndex, rows) => {
          newBody = !rowIndex
          addGroupAction = false
          newGroup = false
          endGroup = false
          groupingAction = {}
          // Last record?
          if (rowIndex >= recordCount - 1) {
            // Show totals
            addGroupAction = true
            groupingAction.aggregators = groupingAction.aggregators || []
            groupingAction.aggregators.push(totalAggregator)
          }
          for (let grouping of groupings) {
            field = grouping.by[0]
            aggregator = aggregatorMap.get(grouping)
            // Are we at the start of a new group?
            if (newGroup || !rowIndex || row[field] !== rows[rowIndex - 1][field]) {
              // New group
              newGroup = true
              addGroupAction = true
              bodyClass = grouping.bodyClass
              if (bodyClass && !usedClasses.has(bodyClass)) {
                usedClasses.add(bodyClass)
                bodyClasses.push(...Array.isArray(bodyClass) ? bodyClass : [bodyClass])
              }
              if (grouping.newBody) newBody = true
              if (grouping.showSeparator) groupingAction.showSeparator = grouping.showSeparator
              if (typeof grouping.caption === 'function') groupingAction.caption = grouping.caption
              groupingAction.emptyRows = grouping.emptyRows
              // Reset aggregator for new group
              if (aggregator) {
                aggregator = this.newAggregator(aggregateColumns, grouping)
                aggregatorMap.set(grouping, aggregator)
              }
            }
            // Aggregate row for group
            if (aggregator) this.aggregateRows(row, aggregateColumns, aggregator, rowIndex, rows)
            // Are we at the end of our group?
            if (endGroup || rowIndex >= recordCount - 1 || row[field] !== rows[rowIndex + 1][field]) {
              // Last of this group
              endGroup = true
              if (aggregator) {
                addGroupAction = true
                groupingAction.aggregators = groupingAction.aggregators || []
                groupingAction.aggregators.push(aggregator)
              }
            }
          }
          // Aggregate for totals
          this.aggregateRows(row, aggregateColumns, totalAggregator, rowIndex, rows)
          if (addGroupAction) {
            if (groupingAction.aggregators) groupingAction.aggregators.reverse() // Display them in reverse order
            row.__groupAction = groupingAction
          }
          if (!group || newBody) {
            // Create new group body
            group = {
              class: bodyClasses,
              rows: []
            }
            result.push(group)
          }
          group.rows.push(row)
          return result
        }, [])
        return groupedData
      }
      // Not grouping result
      this.isGrouped = false
      return data
    }
  }
}
